import { render, staticRenderFns } from "./notification-details.vue?vue&type=template&id=e638f7a4&"
import script from "./notification-details.vue?vue&type=script&lang=js&"
export * from "./notification-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports